import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  HStack,
  Badge,
  Button,
} from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const MentionsLegales = () => {
  const sections = [
    {
      id: 'editeur',
      title: 'Éditeur du site',
      emoji: 'ℹ️',
      items: [
        'Le site Groupe Solarenov est édité par la société Groupe Solarenov.',
        'Forme juridique : Société par actions simplifiée (SAS).',
        'Capital social : entièrement libéré.',
        'Responsable de la publication : Direction communication Groupe Solarenov.',
        'Contact principal : formulaire dédié sur la page « Contact ».',
      ],
    },
    {
      id: 'hebergement',
      title: 'Hébergement',
      emoji: '💻',
      items: [
        'Le site est hébergé par un prestataire certifié situé dans l’Union européenne.',
        'Les infrastructures répondent aux normes de sécurité et de continuité de service en vigueur.',
        'Pour toute demande relative à l’hébergement, merci d’utiliser le formulaire de contact.',
      ],
    },
    {
      id: 'activite',
      title: 'Activité',
      emoji: '🚀',
      items: [
        'Groupe Solarenov accompagne les particuliers et les professionnels dans leurs projets de rénovation énergétique.',
        'Nos services incluent l’analyse des besoins, l’étude des aides publiques, le suivi administratif et la coordination avec les partenaires installateurs.',
        'Le site met à disposition des informations générales, des ressources pédagogiques et des formulaires de prise de contact.',
      ],
    },
    {
      id: 'donnees',
      title: 'Données personnelles',
      emoji: '🔒',
      items: [
        'Les informations collectées via les formulaires sont limitées aux données strictement nécessaires au traitement de votre demande (identité, coordonnées, informations relatives au logement).',
        'Ces données sont traitées conformément au Règlement Général sur la Protection des Données (UE) 2016/679.',
        'Responsable du traitement : Groupe Solarenov.',
        'Durée de conservation indicative : 24 mois à compter du dernier échange, sauf obligation légale différente.',
        'Vous pouvez exercer vos droits d’accès, de rectification, d’opposition, d’effacement, de portabilité et de limitation en formulant votre demande depuis la page « Contact ».',
      ],
    },
    {
      id: 'propriete',
      title: 'Propriété intellectuelle',
      emoji: '📚',
      items: [
        'L’ensemble des contenus présents sur le site (textes, visuels, graphismes, vidéos, logos, icônes) sont protégés par le droit d’auteur et demeurent la propriété de Groupe Solarenov ou de ses partenaires.',
        'Toute reproduction, représentation ou diffusion sans autorisation écrite est interdite.',
      ],
    },
    {
      id: 'responsabilite',
      title: 'Responsabilité',
      emoji: '⚖️',
      items: [
        'Les informations communiquées sur le site sont fournies à titre indicatif. Malgré le soin apporté à leur mise à jour, des erreurs ou omissions peuvent subsister.',
        'Groupe Solarenov ne saurait être tenue responsable des conséquences directes ou indirectes liées à l’utilisation du site ou des informations publiées.',
        'Des liens externes peuvent être proposés ; Groupe Solarenov décline toute responsabilité quant au contenu des sites tiers.',
      ],
    },
    {
      id: 'mediation',
      title: 'Médiation',
      emoji: '🤝',
      items: [
        'Conformément à l’article L.612-1 du Code de la consommation, tout client consommateur peut recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d’un litige.',
        'Les modalités précises et coordonnées du médiateur sont communiquées sur simple demande via le formulaire de contact.',
      ],
    },
    {
      id: 'contact',
      title: 'Contact',
      emoji: '✉️',
      items: [
        'Pour toute question relative au site ou à son contenu, vous pouvez joindre notre équipe en remplissant le formulaire disponible sur la page « Contact ».',
        'Nos équipes s’engagent à répondre dans les meilleurs délais dans le cadre de la réglementation en vigueur.',
      ],
    },
  ];

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="linear-gradient(135deg, #0ea5e9 0%, #6366f1 50%, #8b5cf6 100%)"
          py={{ base: 14, lg: 18 }}
        >
          <Container maxW="1200px" px={5}>
            <Heading as="h1" size={{ base: 'xl', md: '2xl' }} color="white" fontWeight={900} textAlign="center">
              📜 Mentions légales
            </Heading>
            <Text mt={4} color="white" fontSize={{ base: 'md', md: 'lg' }} textAlign="center" opacity={0.85}>
              Transparence, conformité et protection de vos données au cœur de notre engagement.
            </Text>
          </Container>
        </Box>

        <Container maxW="1200px" px={5} py={12}>
          <Box bg="white" borderRadius="3xl" p={{ base: 6, md: 10 }} boxShadow="0 25px 70px rgba(30,64,175,0.12)" position="relative" overflow="hidden">
            <Box
              position="absolute"
              top="-120px"
              right="-120px"
              w="240px"
              h="240px"
              bg="linear-gradient(135deg, rgba(99,102,241,0.15), rgba(14,165,233,0.05))"
              borderRadius="full"
              filter="blur(0px)"
            />
            <Stack spacing={10} position="relative">
              <Stack spacing={3}>
                <Badge
                  alignSelf="flex-start"
                  bg="rgba(14,165,233,0.1)"
                  color="teal.600"
                  px={3}
                  py={1.5}
                  borderRadius="full"
                  fontWeight={600}
                  fontSize="xs"
                  letterSpacing="0.08em"
                  textTransform="uppercase"
                >
                  Cadre légal & conformité
                </Badge>
                <Heading as="h2" size={{ base: 'lg', md: 'xl' }} color="gray.800" fontWeight={800} lineHeight={1.2}>
                  Comprendre nos engagements réglementaires en un coup d’œil
                </Heading>
                <Text color="gray.600" fontSize={{ base: 'md', md: 'lg' }} maxW="4xl">
                  Cette page présente les informations essentielles relatives à l’édition du site, à la protection des données, à la propriété intellectuelle et aux voies de contact prévues pour les utilisateurs.
                </Text>
              </Stack>

              <Box borderTop="1px solid" borderColor="gray.100" />

              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 6, md: 8 }}>
                {sections.map((section) => (
                  <Box
                    key={section.id}
                    border="1px solid"
                    borderColor="rgba(79,70,229,0.12)"
                    borderRadius="2xl"
                    p={{ base: 5, md: 6 }}
                    bg="linear-gradient(135deg, rgba(248,250,252,1) 0%, rgba(255,255,255,1) 70%)"
                    boxShadow="0 12px 35px rgba(15,23,42,0.06)"
                    transition="all 0.3s ease"
                    _hover={{ transform: 'translateY(-6px)', boxShadow: '0 18px 40px rgba(59,130,246,0.18)' }}
                  >
                    <HStack spacing={3} align="center" mb={4}>
                      <Box
                        w={12}
                        h={12}
                        borderRadius="xl"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg="linear-gradient(135deg, rgba(14,165,233,0.18), rgba(99,102,241,0.18))"
                        fontSize="xl"
                      >
                        {section.emoji}
                      </Box>
                      <Heading as="h3" size="md" color="gray.800">
                        {section.title}
                      </Heading>
                    </HStack>

                    <VStack align="start" spacing={3} color="gray.600">
                      {section.items.map((item, index) => (
                        <HStack key={index} align="start" spacing={3}>
                          <Box mt={1} w={1.5} h={1.5} borderRadius="full" bg="blue.500" opacity={0.7} flexShrink={0} />
                          <Text lineHeight={1.6}>{item}</Text>
                        </HStack>
                      ))}
                    </VStack>
                  </Box>
                ))}
              </SimpleGrid>

              <Box
                borderRadius="2xl"
                p={{ base: 6, md: 8 }}
                bg="linear-gradient(135deg, rgba(14,165,233,0.12), rgba(59,130,246,0.12))"
                border="1px solid rgba(59,130,246,0.2)"
              >
                <Stack spacing={4} align={{ base: 'flex-start', md: 'center' }} direction={{ base: 'column', md: 'row' }} justify="space-between">
                  <Box>
                    <Heading as="h3" size="md" color="blue.700" mb={2}>
                      Besoin d’un accompagnement ?
                    </Heading>
                    <Text color="blue.700" opacity={0.85} maxW="2xl">
                      Notre équipe conformité répond à vos questions relatives à la protection des données, aux mentions légales ou aux obligations réglementaires applicables.
                    </Text>
                  </Box>
                  <Button
                    as="a"
                    href="/contact"
                    bg="blue.600"
                    color="white"
                    size="lg"
                    borderRadius="full"
                    px={10}
                    py={6}
                    _hover={{ bg: 'blue.500', transform: 'translateY(-2px)' }}
                    transition="all 0.2s ease"
                  >
                    Contacter l’équipe
                  </Button>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default MentionsLegales;
